import React, { FC } from 'react';
import MuiInputAdornment, { InputAdornmentProps as MuiInputAdornmentProps } from '@material-ui/core/InputAdornment';
import { Uds } from '../../types';

export type InputAdornmentProps = Uds<MuiInputAdornmentProps & {}>;

export const InputAdornment: FC<React.PropsWithChildren<InputAdornmentProps>> = ({ dataTest, ...props }) => (
  <MuiInputAdornment data-test={dataTest} {...props} />
);
